<template>
<div>
    <b-container>
        <b-row>
            <b-col class="headerpic">
                <img :src="wurl+'/imgsrv/'+this.headerpic">
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <br>
                <b-breadcrumb :items="items"></b-breadcrumb>
            </b-col>
        </b-row>
        <b-row class="content">
            <b-col>
                <div v-html="content"></div>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="6" md="6" sm="12" xs="12">
                <div class="contactform">
                    <b-form @submit="onSubmit" @reset="onReset" v-if="show">
                        <b-form-group id="input-group-1" label="Adresse email:" label-for="input-1" description="Nous ne partagerons jamais votre e-mail avec qui que ce soit.">
                            <b-form-input id="input-1" v-model="form.email" type="email" required placeholder="Votre adresse email"></b-form-input>
                        </b-form-group>

                        <b-form-group id="input-group-2" label="Nom:" label-for="input-2">
                            <b-form-input id="input-2" v-model="form.name" required placeholder="Votre nom"></b-form-input>
                        </b-form-group>

                        <b-form-group id="input-group-3" label="Prénom:" label-for="input-3">
                            <b-form-input id="input-3" v-model="form.surname" required placeholder="Votre prénom"></b-form-input>
                        </b-form-group>

                        <b-form-group id="input-group-4" label="Tél/Mobile:" label-for="input-4">
                            <b-form-input id="input-4" v-model="form.tel" required placeholder="Votre numéro téléphone ou mobile"></b-form-input>
                        </b-form-group>

                        <b-form-group id="input-group-5" label="Messages:" label-for="input-5">
                        <b-form-textarea
      id="textarea"
      v-model="form.text"
      required
      placeholder="Votre message..."
      rows="3"
      max-rows="6"
    ></b-form-textarea>
                        </b-form-group>
                        <b-button type="submit" variant="primary">Envoyer</b-button>
                        <b-button type="reset" variant="danger" class="cancelbutton">Annuler</b-button>
                    </b-form>
                    
                </div>
                <br><br>
            </b-col>
            <b-col lg="6" md="6" sm="12" xs="12">
                <div class="mapgoogle">
                  <div class="map-responsive">
             <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3774.462832195564!2d47.525712851204965!3d-18.910897112248943!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x21f07dfd824be36f%3A0x89c3b23ca0274bab!2sTailleur%20Gilbert%20Rakotomanana!5e0!3m2!1sfr!2smg!4v1591538723404!5m2!1sfr!2smg" width="600" height="450" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
            </div>
            </div>
            <br><br>
            </b-col>
        </b-row>
    </b-container>
</div>
</template>

<script>
import axios from 'axios'
import {
    globalSiteSetting
} from "../main.ts";
export default {
    data() {
        return {
            wurl: globalSiteSetting.siteurl,
            items: [{
                    text: 'Accueil',
                    to: '/'
                },
                {
                    text: 'Contact'
                }
            ],
            content: '',
            headerpic:'ajaxloader.gif',
            form: {
                email: '',
                name: '',
                surname: '',
                tel: '',
                text:''
                
            },
            show: true
        }
    },
    methods: {
        retrievedata() {
            var app = this
            var weburl = this.wurl
            axios.get(weburl + '/api.data.php?req=content&p=contact&auth=razafy', {
                    crossDomain: true
                })
                .then(response => {
                    //console.log('title is:'+ response.data.title)
                    // console.log('content is:'+ response.data.content)
                    console.log('headerpic is:' + response.data.headerpic)

                    this.content = response.data.content
                    this.headerpic = response.data.headerpic

                })
        },
        onSubmit(evt) {
            evt.preventDefault()
            //alert(JSON.stringify(this.form))
            var weburl = this.wurl;
            this.contenttosendtomail = 'Nom:'+this.form.name + ' ' + '<br>'+'Prénom:'+this.form.surname+'<br>'+'Tél:'+this.form.tel+'<br>'+'Email:'+this.form.email+'<br>'+'Message:'+this.form.text 
          var url = weburl  +'/api.data.php?req=postmail&type=contact&content='+this.contenttosendtomail+'&auth=razafy'
          var urlencoded = encodeURI(url)
          
         axios.get(urlencoded)
         .then(response => {
           console.log('status is:'+ response.data.message)
            //console.log('content is:'+ response.data.content)
            alert('Message envoyé avec succès')

          })


        },
        onReset(evt) {
            evt.preventDefault()
            // Reset our form values
            this.form.email = ''
            this.form.name = ''
            this.form.surname = ''
            this.form.tel = ''
            this.form.text = ''
            
            // Trick to reset/clear native browser form validation state
            this.show = false
            this.$nextTick(() => {
                this.show = true
            })
        },
         scrollToTop() {
           // scroll on top every load page        
                window.scrollTo(0,0);
           }
    },
    mounted() {
        this.retrievedata()
        this.scrollToTop()
    }
}
</script>
